module.exports = __webpack_public_path__ + "h5/img/PDF2.9489a3c4.jpg";